import style from "../style.scss";

import { useState, useRef, useEffect } from "preact/hooks";
import Link from "../../../link";
import IconDown from "../../../icons/down";
import { mergeClasses } from "../../../helpers";
import namedRoutes from "../../../../settings/routes";
import enabledFeatures from "../../../../settings/enabledFeatures";

const SubMenu = () => {
  const [menuActive, setMenuActive] = useState(false);
  const navRef = useRef(null);

  const handleToggle = () => {
    setMenuActive(!menuActive);
  };

  const handleClickOutside = (event) => {
    if (navRef.current && !navRef.current.contains(event.target)) {
      // Close the menu if clicked outside
      setMenuActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <li
      class={mergeClasses([
        style.subMenu,
        menuActive ? style.subMenuActive : null,
      ])}
      role="menuitem"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <button
        class={style.subMenuToggleButton}
        aria-label="Toggle submenu"
        onClick={handleToggle}
        ref={navRef}
      >
        <span class={style.buttonText}>More</span>
        <span class={style.buttonIcon}>
          <IconDown open={menuActive} />
        </span>
      </button>

      <ul class={style.subMenuItems} role="menu" aria-label="Submenu">
        <li role="menuitem">
          <Link activeClassName={style.current} href="/classes">
            Community Classes
          </Link>
        </li>
        <li role="menuitem">
          <Link activeClassName={style.current} href="/history">
            History
          </Link>
        </li>
        <li role="menuitem">
          <Link activeClassName={style.current} href="/sponsors">
            Sponsors
          </Link>
        </li>
        <li role="menuitem">
          <Link activeClassName={style.current} href="/vendors">
            Vendors
          </Link>
        </li>
      </ul>
    </li>
  );
};

export default SubMenu;
